import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../api";

export default function Unsubscribe() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | success | error | missing

  useEffect(() => {
    const email = searchParams.get("email");
    if (!email) { setStatus("missing"); return; }

    api.unsubscribe({ email })
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [searchParams]);

  return (
    <div style={{ minHeight: "100vh", background: "#F7F1DF", display: "flex", alignItems: "center", justifyContent: "center", padding: "2rem" }}>
      <div style={{ background: "#fff", borderRadius: 20, maxWidth: 480, width: "100%", overflow: "hidden", boxShadow: "0 8px 40px rgba(0,0,0,0.08)" }}>
        <div style={{ background: "#8A1613", padding: "28px 36px" }}>
          <p style={{ margin: 0, fontSize: "1.3rem", fontWeight: 900, color: "#fff", fontFamily: "'Outfit',Arial,sans-serif" }}>
            🫀 The Health Plug
          </p>
        </div>
        <div style={{ padding: "36px" }}>
          {status === "loading" && (
            <p style={{ color: "rgba(11,11,11,0.6)" }}>Processing your request…</p>
          )}
          {status === "success" && (
            <>
              <h2 style={{ fontFamily: "'Outfit',Arial,sans-serif", fontWeight: 900, fontSize: "1.5rem", color: "#0B0B0B", margin: "0 0 12px" }}>
                You've been unsubscribed.
              </h2>
              <p style={{ color: "rgba(11,11,11,0.6)", lineHeight: 1.8, margin: "0 0 24px" }}>
                You won't receive any more newsletters from us. We're sorry to see you go!
              </p>
              <Link to="/" style={{ background: "#8A1613", color: "#fff", padding: "12px 24px", borderRadius: 100, textDecoration: "none", fontWeight: 700, fontFamily: "'Outfit',Arial,sans-serif", fontSize: "0.9rem" }}>
                Back to Home
              </Link>
            </>
          )}
          {status === "error" && (
            <>
              <h2 style={{ fontFamily: "'Outfit',Arial,sans-serif", fontWeight: 900, fontSize: "1.5rem", color: "#0B0B0B", margin: "0 0 12px" }}>
                Something went wrong.
              </h2>
              <p style={{ color: "rgba(11,11,11,0.6)", lineHeight: 1.8, margin: "0 0 24px" }}>
                We couldn't process your request. Please try again or contact us.
              </p>
              <Link to="/" style={{ background: "#8A1613", color: "#fff", padding: "12px 24px", borderRadius: 100, textDecoration: "none", fontWeight: 700, fontFamily: "'Outfit',Arial,sans-serif", fontSize: "0.9rem" }}>
                Back to Home
              </Link>
            </>
          )}
          {status === "missing" && (
            <>
              <h2 style={{ fontFamily: "'Outfit',Arial,sans-serif", fontWeight: 900, fontSize: "1.5rem", color: "#0B0B0B", margin: "0 0 12px" }}>
                Invalid link.
              </h2>
              <p style={{ color: "rgba(11,11,11,0.6)", lineHeight: 1.8, margin: "0 0 24px" }}>
                This unsubscribe link is missing an email address. Please use the link from your email.
              </p>
              <Link to="/" style={{ background: "#8A1613", color: "#fff", padding: "12px 24px", borderRadius: 100, textDecoration: "none", fontWeight: 700, fontFamily: "'Outfit',Arial,sans-serif", fontSize: "0.9rem" }}>
                Back to Home
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
